import { motion } from "framer-motion";
import { ShieldCheck, Clock, LogOut } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { NotificationBell } from "@/components/NotificationBell";
import { BotToggle } from "@/components/BotToggle";

export const TopBar = ({ title, isAdmin, scheduleMode, setScheduleMode, inWindow, user, onLogout }) => {
  return (
    <header
      data-testid="app-topbar"
      className="min-h-[64px] shrink-0 bg-white border-b border-[#E7E2DA] px-4 sm:px-6 py-2 flex items-center justify-end sm:justify-between gap-3"
    >
      <h1 className="hidden sm:block font-display text-xl font-normal text-[#1A1A1A] truncate min-w-0" data-testid="topbar-title">
        {title}
      </h1>

      <div className="flex items-center gap-2 justify-end shrink-0">
        <BotToggle />
        <motion.div
          data-testid="schedule-status-pill"
          initial={{ opacity: 0, y: -4 }}
          animate={{ opacity: 1, y: 0 }}
          className={`hidden sm:flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-medium border ${
            inWindow
              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
              : "bg-[#F1EBE1] text-[#8A7352] border-[#E0D3BC]"
          }`}
        >
          <span className="relative flex h-2 w-2">
            <span className={`absolute inline-flex h-full w-full rounded-full opacity-75 animate-ping ${inWindow ? "bg-emerald-400" : "bg-[#C9B8A9]"}`} />
            <span className={`relative inline-flex h-2 w-2 rounded-full ${inWindow ? "bg-emerald-500" : "bg-[#C9B8A9]"}`} />
          </span>
          {inWindow ? "Atención de citas activa" : "Fuera de horario"}
        </motion.div>

        {isAdmin && (
        <div className="hidden md:flex items-center gap-1.5 rounded-full border border-[#E7E2DA] bg-[#FAF8F5] pl-2.5 pr-1 py-1">
          <Clock className="h-3.5 w-3.5 text-[#A79E90]" />
          <Select value={scheduleMode} onValueChange={setScheduleMode}>
            <SelectTrigger data-testid="schedule-simulator-toggle" className="h-7 border-0 shadow-none bg-transparent text-xs font-medium text-[#1A1A1A] focus:ring-0 gap-1 px-1">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="auto" data-testid="schedule-mode-auto">Horario real (Madrid)</SelectItem>
              <SelectItem value="in_window" data-testid="schedule-mode-in">Simular: en horario</SelectItem>
              <SelectItem value="outside_window" data-testid="schedule-mode-out">Simular: fuera de horario</SelectItem>
            </SelectContent>
          </Select>
        </div>
        )}

        <div className="hidden lg:flex items-center gap-1.5 text-xs font-medium text-[#1A1A1A] bg-[#C9B8A9] rounded-full px-3 py-1.5">
          <ShieldCheck className="h-3.5 w-3.5" /> RGPD
        </div>

        <NotificationBell />

        {user && (
          <div className="flex items-center gap-2 pl-1">
            <span className="hidden xl:block text-xs text-[#8A7E70] max-w-[160px] truncate" data-testid="topbar-user-email">{user.email}</span>
            <button
              data-testid="logout-btn"
              onClick={onLogout}
              title="Cerrar sesión"
              className="h-9 w-9 rounded-full border border-[#E7E2DA] bg-[#FAF8F5] flex items-center justify-center text-[#6B6157] hover:bg-[#F1EBE1] transition-colors"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
